import { instanceToInstance, plainToInstance, type ClassConstructor } from "class-transformer";
import MobileDetect from "mobile-detect";
//import { v1 as uuidv1 } from "uuid";
import path from "path";
import short from "short-uuid";
import { ConnKind, AreaKind, UserAuthGroup } from "@/enums";
import moment from "moment";
import "moment/locale/ko";
import { number } from "echarts";
import AppError from "~/models/errors/app-error";
import { PageInfo } from "~/models/core-types";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import { CodeDto } from "~/models/dto-types";

class CommonUtils {

	/**
	 * 주소 문자열 비교용: 괄호 블록 제거 → 연속 공백 축소 → trim.
	 * BPM siteAddr·설비 상세주소 중복 판별에 공통 사용.
	 */
	static normalizeAddrForCompare(raw: string | null | undefined): string {
		return String(raw ?? "")
			.replace(/\s*\([^)]*\)\s*/g, " ")
			.replace(/\s+/g, " ")
			.trim();
	}

	/**
	 * ID 를 생성한다. (중간에 비어 있는 수가 있으면 비어 있는 수를 리턴)
	 * @param numbers
	 * @returns
	 */
	static getNewId(numbers: number[]) {
		if (numbers.length <= 0) return 1;

		numbers.sort((a, b) => {
			return a - b;
		});

		//빈값 찾기
		for (let i = 0; i < numbers.length; i++) {
			const num = i + 1;

			if (num !== numbers[i]) return num;
		}

		return numbers[numbers.length - 1] + 1;
	}

	/**
	 * ID(Max)를 생성한다.
	 * @param numbers
	 */
	static getNewMaxId(numbers: number[]) {
		if (numbers.length <= 0) return 1;

		return Math.max.apply(null, numbers) + 1;
	}

	/**
	 * UUID를 생성한다.
	 * @returns uuid
	 */
	static generateUUID() {
		/*
    let options = {
      node: // 바이트값 6개
      clockseq: // 클럭 시퀀스 (0 - 0x3fff 사이 값)
      msecs: // 밀리초
      nsecs: // 나노초
      random: // 16개의 랜덤 바이트값
      rng: // random 변수를 대체할 16개의 랜덤 바이트값을 반환하는 함수
    } 
    */
		//return uuid.v1();
		//return uuidv1();
		return short.generate();
	}

	/**
	 * 객체를 복제한다.
	 * @param obj 객체 (클래스)
	 * @returns 복제된 객체
	 */
	static deepClone<T>(obj: T) {
		return instanceToInstance<T>(obj);
	}

	static toJson(obj: object) {
		return JSON.stringify(obj, null, 2);
	}

  static innerCoordSet(coord:Array<any>){
    let result = [];
    for(let i = 0; i < coord.length; i++){
      if(coord[i].length === 2 && typeof coord[i][0] === 'number' && typeof coord[i][1] === 'number'){
        result.push(coord[i]);
      } else {
        result.push(this.innerCoordSet(coord[i]));
      }
    }
    return result;
  }

  static innerCoordLoop(coord: Array<any>, kakaoFunction: any){
    // console.log(coord)

    // let result = [];

    // let coordResult = this.innerCoordSet(coord);

    // console.log(coordResult);

    // let newCoord = [];

    // for(let i = 0; i < coordResult.length; i++){
    //   newCoord.push(coordResult[i][0]);
    // }
     
    // for(let i = 0; i < newCoord.length; i++){
    //   let newResult = [];
    //   for(let j = 0; j < newCoord[i].length; j++){
    //     newResult.push(new kakaoFunction.maps.LatLng(newCoord[i][j][0], newCoord[i][j][1]));
    //   }
    //   result.push(newResult);
    // }

    //--------------------
    
    // let result = [];

    // if(coord.length === 1){
    //   result.push(this.innerCoordLoop(coord[0], kakaoFunction));
    // } else {

    //   for(let i = 0; i < coord.length; i++){
    //     if(coord[i].length === 2 && typeof coord[i][0] === 'number' && typeof coord[i][1] === 'number'){
    //       result.push(new kakaoFunction.maps.LatLng(coord[i][0], coord[i][1]));
    //     } else {
    //       result.push(this.innerCoordLoop(coord[i], kakaoFunction));
    //     }
    //   }    
    // }







    //------------------
     
    // return result;


    let result = [] as any[];
    

    if(coord[0].length > 2){
      coord[0] = [coord[0]];
    }
   for(let i = 0; i < coord.length; i++){
      let newResult = [];
      for(let j = 0; j < coord[i][0].length; j++){
        newResult.push(new kakaoFunction.maps.LatLng(coord[i][0][j][1], coord[i][0][j][0]));
      }
      result.push(newResult);
    }

    return result;
  }

	/**
	 * 객체가 비어 있는지 체크 (비어 있으면 true)
	 * @param obj
	 * @returns
	 */
	static isNullOrEmpty<T>(obj: T | null | undefined): obj is null | undefined {
		return obj === null || obj === undefined;
	}

	static isEmptyValue(value: string | null | undefined){
		return value !== null && value !== undefined ? value : '-';
	}

	static isStrEmpty<T>(obj: T) {
		return obj === "";
	}

	static isAllEmpty(value: any){
		return typeof value === 'string' ? value.trim() === '' : value === null || value === undefined;
	}

	static isAllStrDataEmpty(value: any, fixedLength?: number){

		if(typeof value === 'string'){
			if(value.trim() === '') return '-';
		}

		if(value === null || value === undefined){
			return '-';
		}

		if(typeof value === 'number'){
			const fixed = fixedLength ?? 1;
			
			if(isNaN(value)) return '-';
			else if(value === null || value === undefined) return '-';
			
			// 값이 0인 경우 바로 "0" 리턴
			if(value === 0) return '0';
			
			// [1] 전달받은 값 자체에 남아 있는 부동소수점 잡음 제거
			// 뺄셈/나눗셈으로 만들어진 값은 잡음을 안고 들어온다. (예: 20.41 - 20.1 === 0.3099999999999987)
			// 이 잡음은 아래 [2] 의 상대 오차 보정으로는 걸러지지 않는다.
			// (자릿수 상쇄가 일어나면 오차가 결과값이 아니라 피연산자 크기에 비례해 남기 때문)
			// 표시 자릿수보다 6자리 아래에서 정규화하므로 표시값에는 영향이 없다.
			const normalizedValue = Number(value.toFixed(Math.min(fixed + 6, 20)));

			// [2] 소수점 자리수로 내림 처리
			// 곱셈 자체가 만드는 오차를 보정한 뒤 내림한다.
			// 보정하지 않으면 35.3 * 100 === 3529.9999999999995 이므로 35.29 로 잘린다.
			// 자릿수와 무관하게 동작하도록 값의 크기에 비례한 오차(상대 오차)만큼만 더해서 보정하며,
			// 실제 값이 35.2999(= 3529.99) 인 경우는 보정 후에도 3529 로 내림되어 버림 동작은 그대로 유지된다.
			const multiplier = Math.pow(10, fixed);
			const scaledValue = normalizedValue * multiplier;
			const correctedValue = scaledValue + Math.abs(scaledValue) * Number.EPSILON * 8;
			const flooredValue = Math.floor(correctedValue) / multiplier;

			// 내림 처리 후에도 0이면 "0" 리턴
			if(flooredValue === 0) return '0';
			
			// 최대 자리수는 지정한 값으로 제한, 최소 자리수는 0으로 설정하여 끝자리 0 생략 허용
			const fmt = new Intl.NumberFormat('ko-KR', {
				minimumFractionDigits: 0,
				maximumFractionDigits: fixed
			});
			
			let formatted = fmt.format(flooredValue);
			
			// 끝자리 0 제거 (예: 123.40 → 123.4, 123.00 → 123)
			if (fixed > 0) {
				// 소수점이 있을 때만 적용 (정수 10, 100 등은 유지)
				if (formatted.includes('.')) {
					// 끝자리 0을 제거하되, 소수점이 모두 0이면 소수점 자체를 제거
					formatted = formatted.replace(/\.?0+$/, '');
				}
			}
			
			return formatted;
		}

		return value;
	}

	static setNumberOnThirdPlace(number: string | number){

	}

	static isPrimitive(value: any) {
		return value === null || (typeof value !== "object" && typeof value !== "function");
	}

	static nameof<T>(name: keyof T) {
		return name;
	}

	/**
	 * Json -> 역직렬화
	 * @param cls 타입
	 * @param json Json
	 * @returns
	 */
	static jsonDeserialize<T>(cls: ClassConstructor<T>, json: string): T | T[] {
		try {
			const deserializeObj: T = JSON.parse(json);

			return plainToInstance(cls, deserializeObj);
		} catch (e) {
			throw new Error("Method not implemented.");
		}
	}

	static jsonSerialize<T>(obj: T | null) {
		if (this.isNullOrEmpty(obj)) return "";

		return JSON.stringify(obj, null, 2);
	}

	/**
	 * 배열을 그룹화 한다.
	 * @param array 배열
	 * @param grouper 그룹할 항목
	 * @returns
	 */
	static groupBy<K, V>(array: V[], grouper: (item: V) => K) {
		return array.reduce((store, item) => {
			const key = grouper(item);
			if (!store.has(key)) {
				store.set(key, [item]);
			} else {
				const g = store.get(key);

				if (!this.isNullOrEmpty(g)) g.push(item);
			}
			return store;
		}, new Map<K, V[]>());
	}

	static range(start: number, end: number) {
		return Array.from(Array(end - start + 1).keys()).map((x) => x + start);
	}

	/**
	 * 자리수
	 * @param length 자리수
	 * @param valueString 값
	 * @returns
	 */
	static fillZero(length: number, valueString: string) {
		return valueString.length >= length ? valueString : new Array(length - valueString.length + 1).join("0") + valueString;
	}

	/**
	 * 랜덤값을 만든다.
	 * @param min
	 * @param max
	 * @returns
	 */
	static random(min: number, max: number) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	/**
	 * 랜덤값을 만든다. (소수점)
	 * @param min
	 * @param max
	 * @returns
	 */
	static dRandom(min: number, max: number) {
		//return parseFloat((Math.random() * (min - max + 1)).toFixed(2));
		return parseFloat((Math.random() * (max - min) + min).toFixed(2));
	}

	/**
	 * 핀번호를 만든다.
	 * @param size 자리수
	 * @returns
	 */
	static getPinNum(size = 6) {
		let pinNum = "";
		for (let i = 0; i < size; i++) {
			pinNum += Math.floor(Math.random() * 10);
		}
		return pinNum;
	}	

	/**
	 * 지정한 열거형의 값에 해당하는지 체크한다.
	 * @param type
	 * @param value
	 * @returns
	 */
	static isEnum<T extends { [s: string]: unknown }>(type: T, value: string | undefined): boolean {
		if (this.isNullOrEmpty(value)) return false;

		const values = Object.values(type);
		return values.includes(value as unknown as T);
	}

	static isNumeric(data: string): boolean {
		return !isNaN(Number(data));
	}

	//사용 안함.
	static convertEnum<T extends { [s: string]: unknown }>(type: T, value: string | undefined): T | undefined {
		try {
			const isEnum = this.isEnum<T>(type, value);

			if (!isEnum) return undefined;
			else return value as unknown as T;
		} catch {
			throw new Error("");
		}
	}

	/**
	 * 파일 이름에서 확장자를 제거한다.
	 * @param fileName 파일 이름
	 * @returns
	 */
	static removeExtName(fileName: string) {
		const extName = path.extname(fileName);
		return path.basename(fileName, extName);
	}

	/**
	 * 파일 이름에서 확장자를 추출한다.
	 * @param fileName 파일 이름
	 * @returns
	 */
	static extractExtName(fileName: string) {
		return fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
	}

	static convertIntEx(s: string | undefined) {
		return this.isNullOrEmpty(s) ? undefined : parseInt(s);
	}

	/**
	 * 숫자의 3자리 마다 , 를 추가한다.
	 * @param number 숫자
	 * @returns
	 */
	static numberWithCommas(number: number, commaNumber: number = 0) {
		if (number === null || number === undefined) return "-";
		if (!typeof number === 'number') return "-";
		
		var parts = number.toFixed(commaNumber).toString().split(".");
		let result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");

		return result;
	}

	/**
	 * 시간 string 포맷 변경
	 * @param date
	 * @returns
	 */
	static timeToString(date: Date, dofw?: boolean) {
		if (!date) {
			return "";
		}
		moment.locale("ko");
		let dayNumber = moment(date).day();
		let koDayOfWeek = ["일", "월", "화", "수", "목", "금", "토"];

		let timeString;

		if (dofw) {
			timeString = moment(date).format(`YYYY-MM-DD(${koDayOfWeek[dayNumber]}) HH:mm`);
		} else {
			timeString = moment(date).format(`YYYY-MM-DD HH:mm`);
		}

		return timeString;
	}

	static getConnKind(header: string | undefined) {
		//헤더가 비어있으면 False(Desktop)
		if (this.isNullOrEmpty(header)) return ConnKind.PC;

		const md = new MobileDetect(header);

		const isMobile = md.phone() !== null || md.mobile() === "UnknownMobile";
		const isTablet = md.tablet() !== null || md.mobile() === "UnknownTablet";

		const result = isMobile || isTablet;
		return result ? ConnKind.Mobile : ConnKind.PC;
	}

	/**
	 * Path에서 QueryString 제거
	 * @param path 경로
	 * @returns
	 */
	static getRemoveQueryString(path: string) {
		if (!path.includes("?")) return path;

		return path.slice(0, path.indexOf("?"));
	}

	/**
	 * 배열 복사 (사용안함 - 프로퍼티가 비어 있음..)
	 * @param sourceArray
	 * @returns
	 */
	static cloneArray<TSource, TTarget>(sourceArray: TSource[]): TTarget[] {
		return sourceArray.map((item) => item as unknown as TTarget);
	}

	/**
	 * Watt -> kWh, MWh 변환
	 * @param watt
	 */
	static wattConvert(watt: number, unit: string) {
		if (unit == "kWh") {
			if (watt > 1000) {
				return {
					value: this.numberWithCommas(watt / 1000, 2),
					unit: "MWh",
				};
			} else if (watt == null) {
				return {
					value: "-",
					unit: "kWh",
				};
			} else {
				return {
					value: this.numberWithCommas(watt, 2),
					unit: "kWh",
				};
			}
		} else if (unit == "kW") {
			if (watt > 1000) {
				return {
					value: this.numberWithCommas(watt / 1000, 2),
					unit: "MW",
				};
			} else if (watt == null) {
				return {
					value: "-",
					unit: "kW",
				};
			} else {
				return {
					value: this.numberWithCommas(watt, 2),
					unit: "kW",
				};
			}
		}
	}

	/**
	 * co2 -> kgCO2, tCO2 변환
	 * @param co2
	 */
	static co2Convert(co2: number) {
		if (co2 > 10000) {
			return {
				value: this.numberWithCommas(co2 / 1000, 2),
				unit: "tCO2",
			};
		} else if (co2 == null) {
			return {
				value: "-",
				unit: "kgCO2",
			};
		} else {
			return {
				value: this.numberWithCommas(co2, 2),
				unit: "kgCO2",
			};
		}
	}

	/**
	 * 주소 노출 텍스트 변환
	 * @param addr
	 * @returns
	 */
	static addrParse(addr: string) {
		let splitAddr = addr.split(" ");
		let parseString = "";

		if (splitAddr[0].length >= 4) {
			parseString += `${splitAddr[0].split("")[0]}${splitAddr[0].split("")[2]}/`;
		} else {
			parseString += `${splitAddr[0].substring(0, 2)}/`;
		}

		parseString += `${splitAddr[1].substring(0, 2)}/${splitAddr[2]}`;

		return parseString;
	}

	/**
	 * 대시보드 이벤트 주소 노출 텍스트 변환
	 * @param addr
	 * @returns
	 */
	static addrParseDashBoard(addr: string, alias: string) {
		let splitAddr = addr.split(" ");
		let parseString = "";

		if (splitAddr[0].length >= 4) {
			parseString += `${alias}/`;
		} else {
			parseString += `${alias}/`;
		}

		parseString += `${splitAddr[1].substring(0, 2)}/${splitAddr[2]}`;

		return parseString;
	}

	/**
	 * 회원상태값에 따른 한글 표기
	 * @param account
	 * made by woonsik
	 */
	static getAccountStatus(account: string) {
		let accountStatus;
		if (account == "active") accountStatus = "사용중";
		else if (account == "lock") accountStatus = "중지";
		else if (account == "leave") accountStatus = "탈퇴";
		else accountStatus = "확인불가";

		return accountStatus;
	}

  static isTimeOrDash(originData: string | null | undefined | Date, dateType: 'hour' | 'day' | 'month'){    
    if(originData === null || originData === undefined){
      return '-';
    }
  
    let type = 'YYYY-MM-DD';

    if(dateType === 'hour') type = 'YYYY-MM-DD HH:mm:ss';
    else if(dateType === 'day') type = 'YYYY-MM-DD';
    else if(dateType === 'month') type = 'YYYY-MM';
    else type = 'YYYY-MM-DD';

    return moment(originData).format(type);
  }

  static getTimeDateType(dateType: number | string){
    let type = 'YYYY-MM-DD';
    if(dateType === 0 || dateType === '0') type = 'YYYY-MM-DD HH:mm:ss';
    else if(dateType === 1 || dateType === '1') type = 'YYYY-MM-DD';
    else if(dateType === 2 || dateType === '2') type = 'YYYY-MM';

    return type;
  }

	/**
	 *
	 * @param originData
	 * @param point
	 * 숫자값에 대한 빈값 처리
	 * made by woonsik
	 */
	static isDataOrDash(originData: number | null | undefined, point?: number) {
		let data;
		if (originData !== null && originData !== undefined && !isNaN(originData)) {
			data = this.numberWithCommas(originData as number, point);
		} else {
			data = "-";
		}
		return data;
	}

	/**
	 *
	 * @param originData
	 * 스트링값에 대한 빈값 처리
	 * made by woonsik
	 */
	static isStrDataOrDash(originData: string | null | undefined) {
		let data;
		if (originData !== null && originData !== "" && originData !== undefined) {
			data = originData;
		} else {
			data = "-";
		}
		return data;
	}

	/**
	 * 긴 주소를 짧게 자르는 처리
	 * @param siteAddr
	 * @returns
	 */
	static setAddrString(siteAddr: string) {
		if (!siteAddr) return "";
		let siteSplit = siteAddr?.split(" ") as string[];
		let siteString = "";

		switch(siteSplit[0]){
			case "서울특별시": 			 siteString = "서울"; break;
			case "부산광역시": 			 siteString = "부산"; break;
			case "대구광역시": 			 siteString = "대구"; break;
			case "인천광역시": 			 siteString = "인천"; break;
			case "광주광역시": 			 siteString = "광주"; break;
			case "대전광역시": 			 siteString = "대전"; break;
			case "울산광역시": 			 siteString = "울산"; break;
			case "세종특별자치시": 	  siteString = "세종"; break;
			case "경기도": 					 siteString = "경기"; break;
			case "충청북도": 				 siteString = "충북"; break;
			case "충청남도": 				 siteString = "충남"; break;
			case "전라남도": 				 siteString = "전남"; break;
			case "전북특별자치도": 		siteString = "전북"; break;
			case "경상북도": 				 siteString = "경북"; break;
			case "경상남도": 				 siteString = "경남"; break;
			case "제주특별자치도": 		siteString = "제주"; break;
			case "강원특별자치도": 		siteString = "강원"; break;
			default: 								siteString = siteSplit[0]; break;
		}

		// if (siteSplit[0] === "충청북도") siteString = "충북";
		// else if (siteSplit[0] === "충청남도") siteString = "충남";
		// else if (siteSplit[0] === "경상남도") siteString = "경남";
		// else if (siteSplit[0] === "경상북도") siteString = "경북";
		// else if (siteSplit[0] === "강원특별자치도") siteString = "강원";
		// else if (siteSplit[0] === "서울특별시") siteString = "서울";
		// else siteString = siteSplit[0];

		return `${siteString}/${siteSplit[1]}/${siteSplit[2]}`;
	}

  /**
   * 
   * @param siteAddr 
   */
  static setAddrChart(addrCode: string, siteAddr: string){
    if(!siteAddr) return "";
    let siteSplit = siteAddr.split(" ") as string[];
    let siteString = "";

    if(addrCode.length == 2){
      if(siteSplit[0] === "충청북도") siteString = "충북";
      else if(siteSplit[0] === "충청남도") siteString = "충남";
      else if(siteSplit[0] === "전라남도") siteString = "전남";
      else if(siteSplit[0] === "경상남도") siteString = "경남";
      else if(siteSplit[0] === "경상북도") siteString = "경북";
      else if(siteSplit[0] === "전라북도") siteString = "전북";
      else siteString = siteSplit[0].substring(0,2);
    } else if(addrCode.length === 5){
      siteString = siteAddr;
    } else if(addrCode.length === 10){
      siteString = siteSplit[2];
    }

    return siteString;
  }

	/**
   * 광역시도 또는 시군구 코드로 동코드를 가져온다.
   */
		static cityOrSigunguCodeToDongCode(cityCode: string, sigunguCode?: string) {

			const defaultSigunguCode = "000";
			const defaultDongCode = "00000";
	
			let sc = CommonUtils.isNullOrEmpty(sigunguCode) ? defaultSigunguCode : sigunguCode;
			if(cityCode === "36") sc = "110";
			return `${cityCode}${sc}${defaultDongCode}`;
		}

		static dongCodeToCityOrSigunguCode(dongCode: string, areaKind: AreaKind, isFill = false) {
			if(areaKind === AreaKind.Country){
				return '0000000000';
			}
			else if(areaKind === AreaKind.City) {
				const cityCode = dongCode.substring(0, 2); 
				return isFill ? cityCode + "00000000" : cityCode;
			}
			else if (areaKind === AreaKind.Sigungu) {
				const sigunguCode = dongCode.substring(0, 5); 
				return isFill ? sigunguCode + "00000" : sigunguCode;
			}
			else
				return dongCode;
			
			//throw new AppError("지원하지 않는 지역 타입 입니다.")
		}

		static areaToRegionCodes(dongCode: string) {
			
			if(dongCode === "00")
				return ["00", "000", "0000000000"];

			if(dongCode.length !== 10)
				throw new AppError("동코드 길이가 올바르지 않습니다.");

			const cityCode = dongCode.substring(0, 2); 
			const sigunguCode = dongCode.substring(2, 5); 
			
			return [cityCode, sigunguCode, dongCode];
		}

		/**
		 * 페이지 정보 객체를 반환한다.
		 * @param pageNo 페이지 번호
		 * @param pageSize 페이지 사이즈
		 * @param count 총 갯수
		 * @returns 
		 */
		static getPageInfo(pageNo: number, pageSize: number, count: number) {
			const pageCount = Math.floor(count / pageSize);
			const totalPage = (count % pageSize) > 0 ? pageCount + 1 : pageCount;
			const isFirstPage = pageNo <= 1;
			const isLastPage = pageNo >= totalPage;

			const pageInfo: PageInfo = {
				isFirstPage: isFirstPage,
				isLastPage: isLastPage,
				pageNo: pageNo,
				pageSize: pageSize,
				totalPage: totalPage,
			}

			return pageInfo;
		}	

  static routerPush(url: string){
    const router = useRouter();

    router.push(url);
  }

  static getWeather(weatherCondition: number){


  }

  static left(sourceStr:string, findStr:string) {
	let index = sourceStr.indexOf(findStr);
	if (index < 0) { return ""; }
	else { return (sourceStr.substring(0, index)); }
  }

  static right(sourceStr:string, findStr:string) {
	let index = sourceStr.indexOf(findStr);
	if(index < 0) { return ""; }
	else { let len = sourceStr.length; return (sourceStr.substring(index+findStr.length, len)); }
  }

  static pad(num:number, size:number) {
	let s = num.toString();
	while (s.length < size) s = "0" + s;
	return s;
  }

  static telValidChk(tel:string) {
	const pattern = /^(02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

	if(pattern.test(tel) === false) { return false; }
	else { return true; }
  }

  static emailValidChk(email:string) {
	const pattern = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-za-z0-9\-]+/;

	if(pattern.test(email) === false) { return false; }
	else { return true; }
  }

  static mobileValidChk(tel:string) {
	const pattern = /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

	if(pattern.test(tel) === false) { return false; }
	else { return true; }

  }

	static objectToString(o) {
		Object.keys(o).forEach(k => {
			if (typeof o[k] === 'object') {
				return CommonUtils.objectToString(o[k]);
			}
			
			o[k] = '' + o[k];
		});
		
		return o;
	}
	
	static firstCapitalize(str: string) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	static installCancel(){
		const router = useRouter();

		Swal.fire({
      html: `<p style="font-size: 15px;">지금까지 작성한 내역이 모두 취소됩니다.<br>취소하시겠습니까?</p>`,
      confirmButtonColor: "#1949e9",
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      width: "85%",
      showCancelButton:true,
    }).then(async (result) => {
      if(result.isConfirmed){
        router.replace('/mobile/installer/owners/list')
      }
    })
	}

	static goInstallerFirstPage(){
		const router = useRouter();

		Swal.fire({
      html: `<p style="font-size: 15px;">설치자 리스트 화면으로 돌아갑니다.<br>진행하시겠습니까?</p>`,
      confirmButtonColor: "#1949e9",
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      width: "85%",
      showCancelButton:true,
    }).then(async (result) => {
      if(result.isConfirmed){
        router.replace('/mobile/installer/owners/list')
      }
    })
	}

	static alertMessage(message: string){
		Swal.fire({
      html: `<p style="font-size: 15px;">${message}</p>`,
      confirmButtonColor: "#1949e9",
      confirmButtonText: "확인",
      width: "85%",
    })
	}

	static FiletoBlobUrl(file: File){
		try{
			let url = URL.createObjectURL(file)
			return url;

		} catch(e){
			return '';
		}
	}

	static blobBufferToFile(blob: Blob | File | string | null | undefined){
		if(!blob) return '';
		
		// 문자열인 경우 (base64 등)
		if(typeof blob === 'string'){
			try{
				// base64 문자열인 경우
				if(blob.startsWith('data:')){
					return blob;
				}
				// base64 문자열을 Blob으로 변환
				const byteCharacters = atob(blob);
				const byteNumbers = new Array(byteCharacters.length);
				for(let i = 0; i < byteCharacters.length; i++){
					byteNumbers[i] = byteCharacters.charCodeAt(i);
				}
				const byteArray = new Uint8Array(byteNumbers);
				const blobObj = new Blob([byteArray], { type: 'image/jpeg' });
				return URL.createObjectURL(blobObj);
			} catch(e){
				return '';
			}
		}
		
		// Blob 또는 File인 경우 직접 URL 생성
		try{
			return URL.createObjectURL(blob);
		} catch(e){
			return '';
		}
	}

	static bigSizeImageByBlobUrl(url: string){
		window.open(url, '_blank', 'location=yes');
	}

	static modalOpen(modal: Modal){
		modal.show();
	}

	static modalClose(modal: Modal){
		modal.hide();
	}

	static byteUnitsCalc(size: number) {
		let calcValue = size;
		let unit = "Byte";
		let byteUnits = ["KB", "MB"];

		for (let i = 0; i < byteUnits.length; i++) {
			if (calcValue > 1024) {
				calcValue = calcValue / 1024;
				unit = byteUnits[i];
			}
		}

		return calcValue.toFixed(1) + unit;
	}

	static percentageCalc(todayProd: number, prevDayProd: number){
		if(prevDayProd === 0){
			return '-';
		}

		return (Math.abs((todayProd - prevDayProd) / prevDayProd * 100).toFixed(1)) + '%';
	}

	static checkAuthGroupTypeForPage(userAuthGroup: UserAuthGroup){
		
	}

	static isRtuManagerOrAdmin(userAuthGroup: UserAuthGroup){
		return userAuthGroup === UserAuthGroup.RtuManufact || userAuthGroup === UserAuthGroup.Admin;
	}

	static valueFormatter(value: any, type: string, codeStore: any){
		if(!value) return '-'


		switch(type){
			case 'engSource': {
				return (codeStore.getMapCode('engSource', value as string) as CodeDto).codeName;
			}
		}
	}

	static unitFormatter(value: number | string, unit: string, commmaNumber: number = 2) {
		if(value === undefined || value === null || value === '-') return {value: '-', unit: unit};

		const formatWithUnit = (val: number, currentUnit: string): { value: string; unit: string } => {

			switch(currentUnit){
				case 'W':{
					if(val > 7000){
						return formatWithUnit(val / 1000, 'kW');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "W"};
					}
				}
				case 'kW':{
					if(val > 7000){
						return formatWithUnit(val / 1000, 'MW');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "kW"};
					}
				}
				case 'MW':{
					if(val > 7000){
						return formatWithUnit(val / 1000, 'GW');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "MW"};
					}
				}
				case 'GW':{
					return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "GW"};
				}
				case 'Wh': {
					if(val > 7000){
						return formatWithUnit(val / 1000, 'kWh');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "Wh"};
					}
				}
				case 'kWh': {
					if(val > 7000){
						return formatWithUnit(val / 1000, 'MWh');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "kWh"};
					}
				}
				case 'MWh': {
					if(val > 7000){
						return formatWithUnit(val / 1000, 'GWh');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "MWh"};
					}
				}
				case 'GWh': {
					return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "GWh"};
				}
				case 'Wp': {
					if(val > 9000){
						return formatWithUnit(val / 1000, 'kWp');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "Wp"};
					}
				}
				case 'kWp': {
					if(val > 9000){
						return formatWithUnit(val / 1000, 'MWp');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "kWp"};
					}
				}
				case 'MWp': {
					if(val > 9000){
						return formatWithUnit(val / 1000, 'GWp');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "MWp"};
					}
				}
				case 'GWp': {
					return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "GWp"};
				}
				case 'm²': {
					if(val > 7000){
						return formatWithUnit(val / 1000, 'km²');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "m²"};
					}
				}
				case 'km²': {
					return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "km²"};
				}
				case 'kgCO2': {
					if(val > 7000){
						return formatWithUnit(val / 1000, 'tCO2');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "kgCO2"};
					}
				}
				case 'tCO2': {
					return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "tCO2"};
				}
				case 'kgCO₂eq': {
					if(val > 7000){
						return formatWithUnit(val / 1000, 'tCO₂eq');
					} else {
						return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "kgCO₂eq"};
					}
				}
				case 'tCO₂eq': {
					return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: "tCO₂eq"};
				}
				default: {
					return {value: this.isAllStrDataEmpty(val, commmaNumber), unit: currentUnit};
				}
			}
		};

		return formatWithUnit(Number(value), unit);
	}

	/**
 * 배열의 단일 필드가 모두 동일한지 확인한다.
 * @param items 확인할 배열
 * @param getFieldValue 각 항목에서 비교할 필드값을 추출하는 함수
 * @returns 모든 항목의 필드값이 동일하면 true
 */
static areAllFieldSame<T>(
	items: T[],
	getFieldValue: (item: T) => any
  ): boolean {
	if (CommonUtils.isNullOrEmpty(items) || items.length <= 1) {
	  return true;
	}
  
	const uniqueValues = new Set(items.map(getFieldValue));
	return uniqueValues.size === 1;
  }
  
  /**
   * 배열의 여러 필드가 모두 동일한지 확인한다.
   * @param items 확인할 배열
   * @param getFieldValues 각 항목에서 비교할 필드값을 추출하는 함수들
   * @returns 모든 필드가 동일하면 true, 하나라도 다르면 false
   */
  static areAllFieldsSame<T>(
	items: T[],
	...getFieldValues: Array<(item: T) => any>
  ): boolean {
	if (CommonUtils.isNullOrEmpty(items) || items.length <= 1) {
	  return true;
	}
  
	// 각 필드별로 고유값 개수 확인
	for (const getFieldValue of getFieldValues) {
	  const uniqueValues = new Set(items.map(getFieldValue));
	  if (uniqueValues.size > 1) {
		return false;
	  }
	}
  
	return true;
  }

  /**
 * 배열의 여러 필드가 모두 동일한지 확인하고 각 필드별 상태를 반환한다.
 * @param items 확인할 배열
 * @param getFieldValues 각 항목에서 비교할 필드값을 추출하는 함수들
 * @returns 각 필드별 동일 여부 배열과 전체 동일 여부
 */
static areAllFieldsSameWithDetails<T>(
	items: T[],
	...getFieldValues: Array<(item: T) => any>
  ): {
	isAllSame: boolean;
	fieldSameResults: boolean[];
	uniqueValues: any[][];
  } {
	if (CommonUtils.isNullOrEmpty(items) || items.length <= 1) {
	  return {
		isAllSame: true,
		fieldSameResults: getFieldValues.map(() => true),
		uniqueValues: items.length > 0 
		  ? getFieldValues.map(getValue => [getValue(items[0])])
		  : []
	  };
	}
  
	const fieldSameResults: boolean[] = [];
	const uniqueValues: any[][] = [];
  
	for (const getFieldValue of getFieldValues) {
	  const unique = Array.from(new Set(items.map(getFieldValue)));
	  uniqueValues.push(unique);
	  fieldSameResults.push(unique.length === 1);
	}
  
	const isAllSame = fieldSameResults.every(isSame => isSame);
  
	return {
	  isAllSame,
	  fieldSameResults,
	  uniqueValues
	};
  }


	/**
	 * 작업 이미지 변경 확인
	 * @returns 
	 */
	static checkChgWorkAttach(originAttachInfos: any, workAttachInfos: any){

		let originAttachSeq = {} as {[x:string] : string[]};
		let workAttachSeq = {} as {[x:string] : string[]};

		for(let i = 0; i < Object.keys(originAttachInfos.value).length; i++){
			let attachCategory = Object.keys(originAttachInfos.value)[i];
			
			if(attachCategory === 'workDetail') continue;
	
			originAttachSeq[attachCategory] = originAttachInfos.value[attachCategory].map((v: any) => v.attachSeq !== null ? v.attachSeq.toString() : v.file.name);
			workAttachSeq[attachCategory] = workAttachInfos.value[attachCategory].map((v: any) => v.attachSeq !== null ? v.attachSeq.toString() : v.file.name);
		}

		let result = true;

		// originAttachSeq와 workAttachSeq의 동일한 key 값 비교
		const allKeys = new Set([...Object.keys(originAttachSeq), ...Object.keys(workAttachSeq)]);

		for (const key of allKeys) {
			const originArray = ((originAttachSeq as {[key: string]: string[]})[key] || []) as string[];
			const workArray = ((workAttachSeq as {[key: string]: string[]})[key] || []) as string[];
			
			// 배열 길이가 다른 경우
			if (originArray.length !== workArray.length) {
				result = false;
				break;
			}
			
			// 배열 요소를 순서대로 비교
			for (let i = 0; i < originArray.length; i++) {
				if (originArray[i] !== workArray[i]) {
					result = false;
					break;
				}
			}
			
			// 이미 다른 경우 루프 종료
			if (!result) {
				break;
			}
		}

		return result;
	}


}


export default CommonUtils;
